import { Box, Typography, Stack, Chip, Tooltip, IconButton } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { stripHtml } from "../CurriculumManagementAdmin/utils/html";
import { viewIconSx, countChipSx } from "../CurriculumManagementAdmin/components/buttonStyles";

/**
 * Curriculums as the agent sees them: what it covers, how many trainings sit under it, and how
 * many of those they have attended. Preview is the only action — nothing here is theirs to change.
 */
export const getCurriculumColumns = (onPreview, attendedByCurriculum) => [
	{
		field: "title",
		headerName: "Curriculum",
		flex: 1.5,
		minWidth: 200,
		renderCell: (params) => (
			<Stack justifyContent="center" sx={{ height: "100%" }}>
				<Typography variant="body2" sx={{ fontWeight: 600 }} noWrap title={params.row.title}>
					{params.row.title}
				</Typography>
			</Stack>
		),
	},
	{
		// Widest column — the count/action columns are fixed so the surplus lands here.
		field: "description",
		headerName: "Description",
		flex: 3,
		minWidth: 260,
		sortable: false,
		// Descriptions are rich text; the table shows the plain-text rendering of it.
		valueGetter: (value) => stripHtml(value),
		renderCell: (params) => (
			<Stack justifyContent="center" sx={{ height: "100%" }}>
				<Typography
					variant="body2"
					color="text.secondary"
					title={params.value}
					sx={{
						display: "-webkit-box",
						WebkitLineClamp: 2,
						WebkitBoxOrient: "vertical",
						overflow: "hidden",
						whiteSpace: "normal",
						lineHeight: 1.4,
					}}
				>
					{params.value || "—"}
				</Typography>
			</Stack>
		),
	},
	{
		field: "trainings",
		headerName: "Trainings",
		width: 130,
		headerAlign: "center",
		align: "center",
		valueGetter: (value) => value.length,
		renderCell: (params) => (
			<Chip
				label={`${params.value} ${params.value === 1 ? "Training" : "Trainings"}`}
				size="small"
				sx={{ ...countChipSx, cursor: "default" }}
			/>
		),
	},
	{
		field: "attended",
		headerName: "Attended",
		width: 120,
		headerAlign: "center",
		align: "center",
		valueGetter: (_value, row) => attendedByCurriculum.get(row.id) ?? 0,
		renderCell: (params) => (
			<Stack justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
				<Typography variant="body2" sx={{ fontWeight: 700, color: params.value > 0 ? "#0F7A53" : "text.secondary" }}>
					{params.value} of {params.row.trainings.length}
				</Typography>
			</Stack>
		),
	},
	{
		field: "actions",
		headerName: "Action",
		width: 110,
		sortable: false,
		filterable: false,
		headerAlign: "center",
		align: "center",
		renderCell: (params) => (
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
				<Tooltip title="Preview trainings">
					<IconButton size="small" onClick={() => onPreview(params.row)} aria-label={`Preview ${params.row.title}`} sx={viewIconSx}>
						<VisibilityOutlinedIcon sx={{ fontSize: 20 }} />
					</IconButton>
				</Tooltip>
			</Box>
		),
	},
];
